<template>
  <div :style="style.container">
    <div :style="style.leftContainer">
      <IconVisibility
        :disabled="viewOnly"
        :visible="tenantTeamTenantUser.selected"
        @click="switchUserVisibility"
        :style="style.iconVisibility"
      />
      <HybridLinkUserImagePrimary
        v-bind="attrs.image"
        :openInCurrentTab="false"
        :src="userImage"
        :tenantUserId="tenantUserId"
        @mouseout="onMouseout"
        @mouseover="onMouseover"
        :style="getUserImageStyle"
      />
      <HybridLinkNameSecondary
        :isRouterLink="false"
        :openInCurrentTab="false"
        :tenantUserId="tenantUserId"
        :style="style.linkName"
      >
        <div
          @mouseout="onMouseout"
          @mouseover="onMouseover"
          :style="getUserNameStyle"
        >
          {{ userName }}
        </div>
      </HybridLinkNameSecondary>
    </div>
    <div
      v-if="!viewOnly"
      :style="style.rightContainer"
    >
      <ButtonTextMuted @click="deleteTenantTeamTenantUser">
        Delete
      </ButtonTextMuted>
    </div>
  </div>
</template>

<script>
  import ButtonTextMuted from '@modules/button/button-text-muted'
  import HybridLinkNameSecondary from '@modules/link/hybrid-link-name-secondary'
  import HybridLinkUserImagePrimary from '@modules/link/hybrid-link-user-image-primary'
  import IconVisibility from '@modules/icon/icon-visibility'
  import { Layout } from '@js/styles'
  import { mapGetters } from 'vuex'
  import { MODAL_WINDOW_NAMES } from '@js/constants'

  export default {
    name: 'UserListRow',
    components: {
      ButtonTextMuted,
      IconVisibility,
      HybridLinkNameSecondary,
      HybridLinkUserImagePrimary,
    },
    props: {
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      tenantTeamTenantUser: {
        type: Object,
        required: false,
        default: () => {},
      },
      viewOnly: {
        type: Boolean,
        required: false,
        default: true,
      },
    },
    data: function () {
      return {
        modalName: MODAL_WINDOW_NAMES.DELETE_TENANT_TEAM_TENANT_USER_PRIMARY,
        attrs: {
          image: {
            display: 'block',
            height: '32px',
            width: '32px',
          },
        },
        style: {
          container: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
            height: '51px',
            padding: `0 ${Layout.space.md}`,
            width: '100%',
          },
          iconVisibility: {
            margin: `0 ${Layout.space.sm} 0 0`,
          },
          leftContainer: {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            justifyContent: 'flex-start',
          },
          linkName: {
            margin: `0 0 0 ${Layout.space.sm}`,
          },
          rightContainer: {
            alignItems: 'center',
            display: 'flex',
            height: '100%',
            justifyContent: 'flex-end',
          },
        },
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      getUserImageStyle: function () {
        return {
          height: '32px',
          minHeight: '32px',
          minWidth: '32px',
          opacity: this.tenantTeamTenantUser.selected ? 1 : 0.5,
          width: '32px',
        };
      },
      getUserNameStyle: function () {
        return {
          color: this.tenantTeamTenantUser.selected ? '' : this.color.dark4(),
        };
      },
      tenantUserId: function () {
        const tenantUser = this.tenantTeamTenantUser.tenantUser;
        return tenantUser ? tenantUser.id : null;
      },
      user: function () {
        const tenantUser = this.tenantTeamTenantUser.tenantUser;
        return tenantUser ? (tenantUser.user ? tenantUser.user : null) : null;
      },
      userImage: function () {
        return this.user ? this.user.image : null;
      },
      userName: function () {
        return `${this.user.firstName} ${this.user.lastName}`;
      },
    },
    methods: {
      deleteTenantTeamTenantUser: function () {
        if (this.disabled) {
          return;
        }
        const payload = {
          tenantTeamTenantUser: this.tenantTeamTenantUser,
        };
        this.$modal.show(this.modalName, payload);
      },
      switchUserVisibility: function () {
        if (this.tenantTeamTenantUser.selected) {
          this.$emit('unselect', this.tenantTeamTenantUser);
        } else {
          this.$emit('select', this.tenantTeamTenantUser);
        }
      },
      onMouseout: function () {
        this.$emit('mouseout', this.tenantTeamTenantUser.tenantUser.id);
      },
      onMouseover: function () {
        this.$emit('mouseover', this.tenantTeamTenantUser.tenantUser.id);
      },
    },
    watch: {
      selected: function (newVal, oldVal) {
        this.$emit('change', newVal);
      },
    },
  };
</script>
